export default __webpack_public_path__ + "static/media/yandex.ba8668a7.svg";